import axiosInstance from "../services/axiosInstance";

export const createCardOrderApi = async (cardData) => {
    // Note: axiosInstance automatically attaches the JWT token from localStorage
    console.log(JSON.stringify(cardData, null, 2));
    const response = await axiosInstance.post("/api/cards", cardData);
    return response.data;
};

export const getTotalCardsApi = async () => {
    // Note: axiosInstance automatically attaches the JWT token from localStorage
    const response = await axiosInstance.get("/api/cards");
    return response.data;
};

export const updateCardDraftApi = async (uniqueCode, cardData) => {
    const response = await axiosInstance.put(`/api/cards/${uniqueCode}`, cardData);
    return response.data;
};

export const getCardBySlugAndCodeApi = async (slug, uniqueCode) => {
    const response = await axiosInstance.get(`/api/cards/${slug}/${uniqueCode}`);
    const { status, cardData } = response.data;
    // Merge status into cardData so consumers can use cardData.status directly
    return { ...cardData, status };
};

export const deleteCardApi = async (uniqueCode) => {
    const response = await axiosInstance.delete(`/api/cards/${uniqueCode}`);
    return response.data;
};

export const getGuestWishesApi = async (uniqueCode) => {
    const response = await axiosInstance.get(`/api/cards/${uniqueCode}/wishes`);
    return response.data;
};

export const postGuestWishApi = async (uniqueCode, wishData) => {
    // wishData: { senderName, message }
    const response = await axiosInstance.post(`/api/cards/${uniqueCode}/wishes`, wishData);
    return response.data;
};

export const getRsvpsApi = async (uniqueCode) => {
    const response = await axiosInstance.get(`/api/cards/${uniqueCode}/rsvp`);
    return response.data;
};

export const postRsvpApi = async (uniqueCode, rsvpData) => {
    // rsvpData: { guestName, attendanceStatus, pax }
    const response = await axiosInstance.post(`/api/cards/${uniqueCode}/rsvp`, rsvpData);
    return response.data;
};

export const deleteRsvpApi = async (uniqueCode, rsvpId) => {
    // Requires JWT auth — only card owner can delete
    await axiosInstance.delete(`/api/cards/${uniqueCode}/rsvp/${rsvpId}`);
    // Returns 204 No Content on success
};

export const deleteGuestWishApi = async (uniqueCode, wishId) => {
    // Requires JWT auth — only card owner can delete
    await axiosInstance.delete(`/api/cards/${uniqueCode}/wishes/${wishId}`);
    // Returns 204 No Content on success
};

export const getGiftsApi = async (uniqueCode) => {
    // Public endpoint — no auth required
    const response = await axiosInstance.get(`/api/cards/${uniqueCode}/gifts`);
    return response.data; // List<GiftPurchaseResponse>
};

export const postGiftPurchaseApi = async (uniqueCode, giftData) => {
    // giftData: { guestName, phoneNumber, giftLink }
    // Public endpoint — no auth required
    const response = await axiosInstance.post(`/api/cards/${uniqueCode}/gifts`, giftData);
    return response.data; // GiftPurchaseResponse: { id, guestName, phoneNumber, giftLink, createdAt }
};
